export default {"src":"/_next/static/media/email.70be4c91.svg","height":22,"width":22};